import { Controller } from "@hotwired/stimulus"

const SCRIPT_POLL_MS = 50

export default class extends Controller {
  static targets = ["container", "token"]
  static values = {
    sitekey: String,
    hl: { type: String, default: "ru" },
    message: String
  }

  connect() {
    this.widgetId = null
    this.captchaToken = null
    this.pollId = null
    this.renderWhenReady()
  }

  disconnect() {
    if (this.pollId) {
      window.clearTimeout(this.pollId)
      this.pollId = null
    }
    if (this.widgetId != null && window.smartCaptcha?.destroy) {
      window.smartCaptcha.destroy(this.widgetId)
    }
    this.widgetId = null
    this.captchaToken = null
  }

  renderWhenReady() {
    if (!window.smartCaptcha) {
      this.pollId = window.setTimeout(() => this.renderWhenReady(), SCRIPT_POLL_MS)
      return
    }
    if (!this.hasContainerTarget || this.widgetId != null) return

    this.widgetId = window.smartCaptcha.render(this.containerTarget, {
      sitekey: this.sitekeyValue,
      hl: this.hlValue,
      callback: (token) => {
        this.captchaToken = token
        if (this.hasTokenTarget) this.tokenTarget.value = token
      }
    })
  }

  submit(event) {
    if (!this.captchaToken) {
      event.preventDefault()
      event.stopImmediatePropagation()
      window.alert(this.messageValue)
      return
    }

    const form = event.target
    if (!(form instanceof HTMLFormElement)) return

    let input = form.querySelector('input[name="captcha_token"]')
    if (!input) {
      input = document.createElement("input")
      input.type = "hidden"
      input.name = "captcha_token"
      form.appendChild(input)
    }
    input.value = this.captchaToken
  }
}
